quoteModule.factory('lenderRetrievalService', ['commonRESTCallService', '$q', 'AppSettings',
    'erateSessionVarsService', 'LenderInfo',
    function(commonRESTCallService, $q, AppSettings, erateSessionVarsService, LenderInfo) {
        var lenderRetrievalService = {};

        // retrieve all lenders for the current dealership
        lenderRetrievalService.retrieveLenders = function() {
            return retrieveLendersPrivate();
        };

        // retrieve all lenders for the current dealership
        lenderRetrievalService.retrieveLenderOptions = function() {
            return retrieveLendersPrivate({addNotApplicableLender: true});
        };

        function retrieveLendersPrivate(resultOptions) {
            var deferred = $q.defer();

            var getLendersUrl = AppSettings.startSPANPlusSvcURL + "lenders/span-dealer/" + erateSessionVarsService.getCurrentDealerSPANId();

            commonRESTCallService.getFromServer(getLendersUrl)
                .success(function(responseData) {
                    var lenderList = responseData.itemList.map(function(element) {
                        var lender = new LenderInfo();
                        lender.populateFromTlcApi(element);
                        return lender;
                    });

                    if (resultOptions && resultOptions.addNotApplicableLender) {
                        var notApplicableLender = new LenderInfo();
                        notApplicableLender.name = "Not Applicable";
                        lenderList.unshift(notApplicableLender);
                        deferred.resolve({notApplicableOption: notApplicableLender, options: lenderList});
                    } else {
                        deferred.resolve(lenderList);
                    }
                }).error(function(responseData, status) {
                    deferred.reject(responseData);
                });

            return deferred.promise;
        }

        // retrieve lender info by Id
        lenderRetrievalService.getLenderById = function(lenderId) {
            var deferred = $q.defer();

            var getLendersByIdUrl = AppSettings.startSPANPlusSvcURL + "lenders/" + lenderId;
            commonRESTCallService.getFromServer(getLendersByIdUrl)
                .success(function(responseData) {
                        var lender = new LenderInfo();
                        lender.populateFromTlcApi(responseData);
                        deferred.resolve(lender);
                }).error(function(responseData, status) {
                    deferred.reject(responseData);
                });

            return deferred.promise;
        };

        // add/update lender
        lenderRetrievalService.saveLender = function(lender) {
            var deferred = $q.defer();

            var postLendersUrl = AppSettings.startSPANPlusSvcURL + "lenders/span-dealer/" + erateSessionVarsService.getCurrentDealerSPANId();
            var lenderData = lender.convertForTlcApi();
            commonRESTCallService.postToServer(postLendersUrl, lenderData)
                .success(function(responseData, status) {
                    var lender = new LenderInfo();
                    lender.populateFromTlcApi(responseData);
                    deferred.resolve(lender);
                }).error(function(responseData, status) {
                    deferred.reject(responseData);
                });

            return deferred.promise;
        };

        // delete a lender by Id
        lenderRetrievalService.deleteLenderById = function(lenderId) {
            var deferred = $q.defer();

            var getLendersUrl = AppSettings.startSPANPlusSvcURL + "lenders/" + lenderId;
            commonRESTCallService.deleteToServer(getLendersUrl)
                .success(function(responseData, status) {
                    if (status==200 && responseData.length == 0){
                        deferred.resolve(responseData);
                    };
                }).error(function(responseData, status) {
                    deferred.reject(responseData);
                });

            return deferred.promise;
        };

        lenderRetrievalService.getProviderSpecificLenders = function(providercode, dealerid) {
            var deferred = $q.defer();

            var getLendersUrl = AppSettings.startSPANPlusSvcURL + "spanproviders/provider-list-items/" +
                providercode + "?dealerid=" + dealerid + "&fieldname=form-lenders";
            commonRESTCallService.getFromServer(getLendersUrl)
            .success(function(responseData, status) {
                if (status == 200){
                    deferred.resolve(responseData);
                };
            }).error(function(responseData, status) {
                deferred.reject(responseData);
            });

            return deferred.promise;
        };

        lenderRetrievalService.getMenuLenders = function(menuDealerId) {
            var deferred = $q.defer();

            const getMenuLendersUrl = AppSettings.startSPANPlusSvcURL + "menuprointegration/menulenders/" + menuDealerId;
            commonRESTCallService.getFromServer(getMenuLendersUrl)
            .success(function(responseData, status) {
                if (status == 200){
                    deferred.resolve(responseData);
                };
            }).error(function(responseData, status) {
                deferred.reject(responseData);
            });

            return deferred.promise;
        };

        return lenderRetrievalService;
    }
]);
